export default class PageNavigationItf {
  reload(forceGet) {
    throw new Error('not implemented')
  }
}
